export default {"src":"/_next/static/image/public/images/flags/flag_853.df3235a8aba614f277a0a64a6fa21844.svg","height":16,"width":24};